import { memo, useEffect, useState } from 'react';
import { Button } from 'src/modules/common/components/Button/Button';
import { MinusIcon } from 'src/modules/common/icons/MinusIcon';
import { PlusIcon } from 'src/modules/common/icons/PlusIcon';

type Props = {
    value?: number;
    onChange?: (newCount: number) => void;
}

export const Counter = memo(({ value, onChange }: Props) => {
    const [count, setCount] = useState(1);

    const handleClick = (newValue: number) => {
        const newCount = newValue < 1 ? 1 : newValue;

        setCount(newCount);
        onChange?.(newCount);
    };

    useEffect(() => {
        if (value !== count) {
            setCount(value || 1);
        }
    }, [count, value]);

    return (
        <div className="vss-counter">
            <Button
                size="md"
                iconOnly={true}
                kind="ghost"
                onClick={() => handleClick(count - 1)}
                className="vss-counter__button"
                disabled={!onChange}
            >
                <div className="vss-counter__icon">
                    <MinusIcon/>
                </div>
            </Button>

            <span className="vss-counter__count">{count}</span>

            <Button
                size="md"
                iconOnly={true}
                kind="ghost"
                onClick={() => handleClick(count + 1)}
                className="vss-counter__button"
                disabled={!onChange}
            >
                <div className="vss-counter__icon">
                    <PlusIcon/>
                </div>
            </Button>
        </div>
    );
});
